import { useEffect, useRef, useState } from 'react'
import { InfoCard2 } from '../../../widgets/components/UI/InfoCard2'
import { useIntl } from 'react-intl'
import { DisplayImage } from '../../../widgets/components/General/DisplayImage'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'
import { Form, Formik } from 'formik'
import TextInput from '../../../widgets/components/Input/TextInput'
import { SelectInput } from '../../../widgets/components/Input/SelectInput'
import { ToolTipUIForModal } from '../../../widgets/components/UI/ToolTipUIForModal'
import deleteicon from '../../../../../media/stakeholders/ic-delete.svg'
import TagInput from '../../../widgets/components/Input/TagInput'
import SelectHeaderDropDown from '../../../widgets/components/Input/SelectInputDropDown'
import SelectSearchInput from '../../../widgets/components/Input/SelectSearchInput'
import { InputWithPhone } from '../../../widgets/components/Input/InputPhone'
import * as Yup from 'yup'
import { FileUpload } from '../../../widgets/components/FileUpload'
import { allowedFileTypes, industryOptions } from '../../../../core/_constants'
import { getFileType } from '../../../../core/_util'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useAuth } from '../../../auth'
import { createBoardMember, getboardMemberDetails, updateBoardMember } from '../core/_requests'
import Skeleton from 'react-loading-skeleton'
import { useFetchIndividualStakeholders } from '../../../../hooks/useFetchIndividualStakeholders'
import { useGetAllDropdownData } from '../../../../hooks/useGetAllDropdownData'
import TagifyInput from '../../../shared-access/components/tagify-input'
import {
  boardMemberSidebarFields,
  ShareholdersTypes,
} from '../../stakeholders-and-investors/core/_constants'
import UserSearchTextInput from '../../components/user-search-text-input'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../../hooks/gtmHelpers'
import { DeleteFileConfirmationModal } from '../../components/delete-file-confirmation-modal'
import moment from 'moment'
import { parsePhoneNumberFromString, isValidPhoneNumber } from 'libphonenumber-js'
import brandingConfig from '../../../../../config/brandingConfig'

export const AddBoardMemberForm = () => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const [modelStatus, setModelStatus] = useState<boolean>(false)
  const [imgName, setImgName] = useState<string>('')
  const [sidebar, setSidebar] = useState(1)
  const [isNotInitialized, setIsNotInitiaized] = useState(true)
  const [isLoading, setLoading] = useState<boolean>(false)
  const [boardMemberDetailsLoading, setboardMemberDetailsLoading] = useState<boolean>(false)
  const [boardMemberDetails, setboardMemberDetails] = useState<any | null>(null)
  const [individualStakeholders, setIndividualStakeholders] = useState<any>(null)
  const [showDeleteModal, setDeleteShowModal] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [deleteFileId, setDeleteFileId] = useState<any>(null)
  const fileRef = useRef<any>([])
  const [clearFormDataShowModal, setClearFormDataShowModal] = useState(false)
  const [clearFormDataLoading, setClearFormDataLoading] = useState(false)
  const formikRef = useRef<any>(null)
  const sidebarOptions = [
    { title: formatMessage({ id: 'Personal Details' }) },
    { title: formatMessage({ id: 'Address' }) },
    { title: formatMessage({ id: 'Other Details' }) },
    { title: formatMessage({ id: 'Documents' }) },
  ]
  const {
    countryOptions,
    stateOptions,
    setCountryId,
    govtIdOptions,
    phoneCodesOptions,
    stateDataLoading,
  } = useGetAllDropdownData(ShareholdersTypes.INDIVIDUAL, formikRef)

  const [files, setFiles] = useState<any>([])
  const { companyId, currentUser } = useAuth()
  const deleteFile = () => {
    if (!deleteFileId) return
    setDeleteLoading(true)
    setFiles(files.filter((file: any) => file.id !== deleteFileId))
    if (formikRef.current) {
      formikRef.current.setFieldValue(
        'fileIds',
        files.filter((file: any) => file.id !== deleteFileId).map((file: any) => file.id)
      )
    }
    setDeleteLoading(false)
    setDeleteShowModal(false)
    toast.success('Document deleted successfully')
  }
  const handleClose = () => {
    setModelStatus(false)
  }

  const handleClearFormData = () => {
    setClearFormDataLoading(true)
    if (formikRef.current) {
      formikRef.current.resetForm()
      setIndividualStakeholders(null)
    }
    setClearFormDataShowModal(false)
    setClearFormDataLoading(false)
  }
  const [searchParams] = useSearchParams()
  const boardMemberId = searchParams.get('boardMemberId')
  const edit = searchParams.get('edit')?.toString() || ' '

  useEffect(() => {
    if (!boardMemberId || !companyId) return
    const fetchTeamDetails = async () => {
      setboardMemberDetailsLoading(true)
      try {
        const {
          data: { data, success },
        } = await getboardMemberDetails(boardMemberId, companyId)
        if (success) {
          setboardMemberDetails(data)
          setImgName(data?.individual?.profileImage?.name)
          setCountryId(data?.individual?.country?.id)
          setboardMemberDetailsLoading(false)
        }
      } catch (error) {
        console.error('Error fetching countries:', error)
      } finally {
        setboardMemberDetailsLoading(false)
      }
    }
    fetchTeamDetails()
  }, [boardMemberId]) // eslint-disable-line react-hooks/exhaustive-deps

  const userSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(1, 'First name must be at least 2 characters')
      .max(50, 'First name must be 50 characters or less')
      .nullable()
      .required('First name is required'),

    lastName: Yup.string()
      .min(1, 'Last name must be at least 2 characters')
      .max(50, 'Last name must be 50 characters or less')
      .nullable()
      .required('Last name is required'),

    email: Yup.string().email('Invalid email address').nullable().required('Email is required'),
    website: Yup.string().url('Invalid url').nullable(),
    nationality: Yup.object()
      .nullable()
      .test('required', 'Nationality is required', function (value: any, ctx) {
        if ((ctx.parent.sidebar === 3 || ctx.parent.sidebar === 4) && (!value || value === '')) {
          return false
        }
        return true
      }),
    address1: Yup.string()
      .nullable()
      .test('maxLength', 'Address 1 cannot be more than 300 characters', function (value) {
        if (!value || value?.length === 0) return true
        return !!(value && value.length <= 300)
      }),

    address2: Yup.string()
      .nullable()
      .test('maxLength', 'Address 2 cannot be more than 300 characters', function (value) {
        if (!value || value?.length === 0) return true
        return !!(value && value.length <= 300)
      }),
    dateOfBirth: Yup.date()
      .nullable()
      .test('is-over-18', 'Board member must be at least 18 years old', function (value) {
        if (!value) return true
        return moment().diff(moment(value), 'years') >= 18
      }),
    phone: Yup.string()
      .nullable()
      .test('phone-number-valid', 'Invalid phone number', function (value, ctx: any) {
        if (!value || value === '') return true

        const selectedPhoneCode = ctx.parent.phoneCode
        const selectedCountryCode = phoneCodesOptions.find(
          (option: any) => option.dial_code === selectedPhoneCode
        )?.code

        if (phoneCodesOptions.length === 0 && ctx.originalValue) {
          return true // Invalid phone code
        }

        try {
          const phoneNumber = String(ctx.originalValue)
          const parsedNumber = parsePhoneNumberFromString(phoneNumber, selectedCountryCode)

          return isValidPhoneNumber(parsedNumber?.number as string)
        } catch (error) {
          return false
        }
      }),
  })

  const initialValues = {
    sidebar: 1,
    profileImage: boardMemberDetails?.individual?.profileImage?.id || '',
    firstName: boardMemberDetails?.individual?.firstName || '',
    lastName: boardMemberDetails?.individual?.lastName || '',
    email: boardMemberDetails?.individual?.email || '',
    phoneCode: boardMemberDetails?.individual?.phoneNumber
      ? boardMemberDetails?.individual?.phoneNumber.split(' ')[0]
      : '+91',
    phone: boardMemberDetails?.individual?.phoneNumber
      ? boardMemberDetails?.individual?.phoneNumber.split(' ')[1]
      : '',
    gender: boardMemberDetails?.individual?.gender || 'Male',
    dateOfBirth: boardMemberDetails?.individual?.dateOfBirth || '',
    workCompanyName: boardMemberDetails?.individual?.workCompanyName || '',
    workIndustry:
      industryOptions.find((option) => option.id === boardMemberDetails?.individual?.workIndustry)
        ?.value || '',
    workExperience: boardMemberDetails?.individual?.workExperience || '',
    boardTaskPreferences: boardMemberDetails?.boardTaskPreferences || '',
    address1: boardMemberDetails?.individual?.address1 || '',
    address2: boardMemberDetails?.individual?.address2 || '',
    country: boardMemberDetails?.individual?.country || '',
    state: boardMemberDetails?.individual?.state || '',
    city: boardMemberDetails?.individual?.city || '',
    zipCode: boardMemberDetails?.individual?.zipCode || '',
    designation: boardMemberDetails?.designation || '',
    nationality: boardMemberDetails?.individual?.nationality || '',
    govtIssuedIdType: boardMemberDetails?.individual?.govtIssuedIdType || '',
    govtIssuedIdNumber: boardMemberDetails?.individual?.govtIssuedIdNumber || '',
    title: boardMemberDetails?.title || '',
    education: boardMemberDetails?.individual?.education || '',
    website: boardMemberDetails?.individual?.website || '',
    skills: boardMemberDetails?.individual?.skills
      ? boardMemberDetails?.individual?.skills.split(',').map((skill: string) => ({
        label: skill,
        value: skill,
      }))
      : '',
    otherAffiliations: boardMemberDetails?.individual?.otherAffiliations
      ? boardMemberDetails?.individual?.otherAffiliations.split(',')
      : '',
    fileIds: boardMemberDetails?.documents?.map((document: any) => document.fileId) || [],
  }

  useEffect(() => {
    if (boardMemberDetails?.documents.length > 0 && isNotInitialized) {
      setFiles(
        boardMemberDetails?.documents.map(({ fileId, name }: { fileId: string; name: string }) => ({
          id: fileId,
          name,
        }))
      )
    }
  }, [isNotInitialized, boardMemberDetails?.documents])

  const handleSubmit = async (values: any, { resetForm }: any) => {
    const rawPayload = {
      firstName: values?.firstName,
      lastName: values?.lastName,
      email: values?.email,
      gender: values?.gender,
      dateOfBirth: values?.dateOfBirth,
      workCompanyName: values?.workCompanyName,
      workIndustry:
        industryOptions.find((option) => option.value === values?.workIndustry)?.id || null,
      workExperience: parseInt(values?.workExperience) || null,
      boardTaskPreferences: values?.boardTaskPreferences,
      address1: values?.address1,
      address2: values?.address2,
      city: values?.city,
      country: values?.country?.value || values?.country?.id,
      state: values?.state ? parseInt(values?.state?.id) || parseInt(values?.state?.value) : null,
      zipCode: values?.zipCode,
      nationality: values?.nationality?.value || values?.nationality?.id,
      profileImage: values.profileImage,
      website: values?.website,
      phoneCode: values?.phoneCode,
      phoneNumber: values?.phone,
      title: values?.title,
      govtIssuedIdType: values?.govtIssuedIdType?.value,
      govtIssuedIdNumber: values?.govtIssuedIdNumber,
      skills: values?.skills
        ? values?.skills.map((option: { label: string; value: string }) => option.label).join(', ')
        : null,
      otherAffiliations:
        Array.isArray(values?.otherAffiliations) && values?.otherAffiliations?.length > 0
          ? values?.otherAffiliations.join(',')
          : values?.otherAffiliations
            ? values?.otherAffiliations
            : null,
      education: values?.education,
      designation: values?.designation,
      fileIds: values?.fileIds,
      individualId: individualStakeholders ? individualStakeholders?.individualId : null,
      isEditPopulatedData: individualStakeholders ? true : null,
    }

    const payload = Object.fromEntries(
      Object.entries(rawPayload).filter(
        ([_, value]) => value !== null && value !== undefined && value !== ''
      )
    )
    try {
      if (!companyId) {
        return
      }
      setLoading(true)
      if (boardMemberId && boardMemberDetails) {
        const {
          data: { success, errors },
        } = await updateBoardMember(payload, companyId, boardMemberId)

        if (success) {
          resetForm()
          setImgName('')
          setFiles([])
          setboardMemberDetails(null)
          navigate('/stakeholders/board-member')
          setLoading(false)
          toast.success(formatMessage({ id: 'Board member  updated successfully' }))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.BoardMembersUpdationSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                board_member_id: boardMemberId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                board_member_first_name: values?.firstName,
                board_member_last_name: values?.lastName,
                board_member_email: values?.email,
                board_member_gender: values?.gender,
                board_member_date_of_birth: values?.dateOfBirth,
                board_member_work_company_name: values?.workCompanyName,
                board_member_work_industry: parseInt(values?.workIndustry) || null,
                board_member_work_experience: parseInt(values?.workExperience) || null,
                board_task_preferences: values?.boardTaskPreferences,
                board_member_website: values?.website,
                board_member_phone_code: values?.phoneCode,
                board_member_phone_number: values?.phone,
                board_member_title: values?.title,
                board_member_govt_issued_id_type: values?.govtIssuedIdType?.value,
                board_member_govt_issued_id_number: values?.govtIssuedIdNumber,
                board_member_skills: values?.skills
                  ? values?.skills
                    .map((option: { label: string; value: string }) => option.label)
                    .join(', ')
                  : null,
                board_member_education: values?.education,
                board_member_designation: values?.designation,
                board_member_file_ids: values?.fileIds,
                board_member_individual_id: individualStakeholders
                  ? individualStakeholders?.individualId
                  : null,
                board_member_is_edit_populated_data: individualStakeholders ? true : null,
              },
            },
          })
        } else {
          toast.error(errors[0])
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.BoardMembersUpdationFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                board_member_id: boardMemberId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                error: errors[0],
              },
            },
          })
        }
      } else {
        const {
          data: { success, errors },
        } = await createBoardMember(payload, companyId)

        if (success) {
          toast.success(formatMessage({ id: 'Board member added successfully' }))
          resetForm()
          setImgName('')
          setFiles([])
          setLoading(false)
          navigate('/stakeholders/board-member')
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.BoardMembersCreationSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                board_member_first_name: values?.firstName,
                board_member_last_name: values?.lastName,
                board_member_email: values?.email,
                board_member_gender: values?.gender,
                board_member_date_of_birth: values?.dateOfBirth,
                board_member_work_company_name: values?.workCompanyName,
                board_member_work_industry: parseInt(values?.workIndustry) || null,
                board_member_work_experience: parseInt(values?.workExperience) || null,
                board_task_preferences: values?.boardTaskPreferences,
                board_member_website: values?.website,
                board_member_phone_code: values?.phoneCode,
                board_member_phone_number: values?.phone,
                board_member_title: values?.title,
                board_member_govt_issued_id_type: values?.govtIssuedIdType?.value,
                board_member_govt_issued_id_number: values?.govtIssuedIdNumber,
                board_member_skills: values?.skills
                  ? values?.skills
                    .map((option: { label: string; value: string }) => option.label)
                    .join(', ')
                  : null,
              },
            },
          })
        } else {
          toast.error(errors[0])
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.BoardMembersCreationFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                board_member_first_name: values?.firstName,
                board_member_last_name: values?.lastName,
                board_member_email: values?.email,
                board_member_gender: values?.gender,
                board_member_date_of_birth: values?.dateOfBirth,
                board_member_work_company_name: values?.workCompanyName,
                board_member_work_industry: parseInt(values?.workIndustry) || null,
                board_member_work_experience: parseInt(values?.workExperience) || null,
                board_task_preferences: values?.boardTaskPreferences,
                board_member_website: values?.website,
                board_member_phone_code: values?.phoneCode,
                board_member_phone_number: values?.phone,
                board_member_title: values?.title,
                board_member_govt_issued_id_type: values?.govtIssuedIdType?.value,
                board_member_govt_issued_id_number: values?.govtIssuedIdNumber,
                board_member_skills: values?.skills
                  ? values?.skills
                    .map((option: { label: string; value: string }) => option.label)
                    .join(', ')
                  : null,
              },
            },
          })
        }
      }
    } catch (err) {
      console.error('Error:', err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.BoardMembersCreationFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    } finally {
      setLoading(false)
    }
  }

  const {
    resetFields,
    onClickBlurText,
    onClickFocusText,
    openUserDropdown,
    setOpenUserDropdown,
    dropdownDataLoading,
    dropDownData,
    setNewEntryButtonClicked,
    fetchIndividualStakeholders,
    stakeHoldersDataLoading,
    fieldClicked,
  } = useFetchIndividualStakeholders(setIndividualStakeholders, setImgName, setCountryId)

  const designationOptions = [
    { id: 1, value: 'Sales', label: 'Sales' },
    { id: 2, value: 'Web Developer', label: 'Web Developer' },
    { id: 3, value: 'Operations', label: 'Operations' },
    { id: 4, value: 'Digital Marketing', label: 'Digital Marketing' },
  ]




  return (
    <>
      <div className='d-flex flex-md-row flex-column'>
        <div className='sidebar-investor-db col-md-1 d-none d-md-flex'>
          {sidebarOptions.map((sideTabs, index) => (
            <ul
              key={index}
              className='text-muted text-active-primary d-md-flex flex-column d-none align-items-left p-0 m-0 cursor-pointer'
            >
              <li
                className={`nav-link text-active-primary py-3 ps-3 d-flex align-items-center ${sidebar === index + 1
                  ? 'border-top-0 border border-bottom-0 border-right-0 border-left-3 border-primary text-primary border-5'
                  : ''
                  }`}
                onClick={() => {
                  setSidebar(index + 1)
                  if (formikRef.current) formikRef.current.setFieldValue('sidebar', index + 1)
                }}
              >
                {formatMessage({ id: sideTabs.title })}
              </li>
            </ul>
          ))}
        </div>
        <div className='mb-2 sidebar-investor-db col-md-1 d-flex d-md-none' style={{ width: '100%' }}>
          <div
            className='d-md-none d-flex'
            style={{
              display: 'flex',
              overflowX: 'scroll',
              whiteSpace: 'nowrap',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {sidebarOptions.map((sideTabs: any, index: number) => (
              <>
                <ul
                  className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent mt-0 flex-nowrap mobile-tab-both my-md-0 mb-2 d-md-none'
                  style={{ display: 'flex', flexWrap: 'nowrap' }}
                >
                  <div>
                    <li
                      key={index}
                      className={
                        `nav-link text-active-primary py-3 ps-3 d-flex align-items-center` +
                        (sidebar === index + 1
                          ? '  border-top-0 border border-left-0 border-right-0 border-bottom-3 border-primary text-primary border-5'
                          : '')
                      }
                      onClick={() => setSidebar(index + 1)}
                    >
                      {formatMessage({ id: sideTabs.title })}
                    </li>
                  </div>
                </ul>
              </>
            ))}
          </div>
        </div>

        <div className='rounded-2 bg-white p-8 w-100'>
          <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={userSchema}
            innerRef={formikRef}
            onSubmit={handleSubmit}
            validateOnMount
          >
            {(formik: any) => {
              setCountryId(formik?.values?.country?.value)

              return (
                <Form>
                  {sidebar === 1 && (
                    <div className='hide-scrollbar' style={{ height: '100vh', overflowY: 'auto' }}>
                      <div className='no-class'>
                        <InfoCard2
                          className='w-100'
                          title={formatMessage({
                            id: `How does ${brandingConfig.brandName} make Board Members Management seamless?`,
                          })}
                          desc={formatMessage({
                            id: 'Easily add and manage board members by filling in their details, such as name, contact information, and profile picture, ensuring all relevant information is centralized and accessible. Keep track of their roles and contributions to maintain an organized and efficient board structure.',
                          })}
                          slug={brandingConfig.helpLinks.addBoardMemberPersonalDetails}
                        />
                      </div>
                      <div className='mb-4'>
                        <h2 className='font-size-16 mb-4'>
                          {formatMessage({ id: 'Personal Details' })}
                        </h2>

                        <div>
                          <div className='d-flex form-label  text-dark font-size-13'>
                            {formatMessage({ id: 'Profile Pic/Logo' })}
                            <ToolTipUIForModal
                              tooltipText={formatMessage({
                                id: 'Add a profile picture of the board member or a logo of the company they represent.',
                              })}
                            />
                          </div>
                          <div className='card position-relative d-inline-flex justify-content-center '>
                            {boardMemberDetailsLoading || stakeHoldersDataLoading ? (
                              <Skeleton
                                height={120}
                                width={120}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                              />
                            ) : (
                              <DisplayImage
                                imgName={imgName ? imgName : 'dummy'}
                                height='120px'
                                width='120px'
                                fit='contain'
                                alt='profile'
                                className='rounded'
                              />
                            )}
                            <FileUpload
                              fileSize={2097152}
                              maxFileNumber={1}
                              allowType={['image/*', '.jpg', '.jpeg', '.png']}
                              metaData={{ module: 'profileimg', isProtected: false }}
                              modalStatus={modelStatus}
                              handleClose={handleClose}
                              handleSuccess={(id: number, name: string) => {
                                setImgName(name)
                                formik.setFieldValue('profileImage', id)
                              }}
                              resourceType='all'
                            />

                            <div
                              className='position-absolute cursor-pointer'
                              style={{ top: 0, right: 0 }}
                            >
                              <img
                                onClick={() => setModelStatus(true)}
                                src={toAbsoluteUrl('/media/icons/duotune/general/pencil.svg')}
                                alt=''
                              />
                            </div>
                          </div>
                          <p className='font-size-12 text-muted' style={{ maxWidth: '120px' }}>
                            {formatMessage({ id: 'Max size 2mb, supported format jpg, png' })}
                          </p>
                        </div>

                        {boardMemberDetailsLoading || stakeHoldersDataLoading ? (
                          <div className='col-xl-12 d-md-flex'>
                            <div>
                              <div
                                className={`card position-relative d-flex justify-content-center`}
                              >
                                <Skeleton
                                  height={130}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                />{' '}
                              </div>
                            </div>
                            <div className='mt-md-8 w-100 px-5 px-md-0 mb-4'>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className='w-100 mt-10'>
                            <div className='row'>
                              <div className='col-md-6 col-12'>
                                <UserSearchTextInput
                                  label={formatMessage({ id: 'First Name' })}
                                  fieldName='firstName'
                                  toolTipText={formatMessage({
                                    id: 'Add first name of the board member here.',
                                  })}
                                  dropdownData={dropDownData}
                                  dropdownDataLoading={dropdownDataLoading}
                                  openUserDropdown={openUserDropdown}
                                  onSelect={(id: string) => {
                                    setOpenUserDropdown(false)
                                    fetchIndividualStakeholders(id, formik)
                                  }}
                                  onNewEntryButtonClick={() => {
                                    setOpenUserDropdown(false)
                                    setIndividualStakeholders(null)
                                    setNewEntryButtonClicked(true)
                                  }}
                                  fieldClicked={fieldClicked}
                                  isDisabled={individualStakeholders?.firstName}
                                  setOpenUserDropdown={setOpenUserDropdown}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter First Name' })}
                                  onFocus={(e: any) =>
                                    onClickFocusText(e, formik, boardMemberDetails)
                                  }
                                  ariaLabel='firstName'
                                  onBlur={(e: any) => onClickBlurText(e, formik)}
                                />
                              </div>

                              <div className='col-md-6 col-12'>
                                <UserSearchTextInput
                                  label={formatMessage({ id: 'Last Name' })}
                                  fieldName='lastName'
                                  toolTipText={formatMessage({
                                    id: 'Add last name of the board member here.',
                                  })}
                                  dropdownData={dropDownData}
                                  dropdownDataLoading={dropdownDataLoading}
                                  openUserDropdown={openUserDropdown}
                                  onSelect={(id: string) => {
                                    setOpenUserDropdown(false)
                                    fetchIndividualStakeholders(id, formik)
                                  }}
                                  onNewEntryButtonClick={() => {
                                    setOpenUserDropdown(false)
                                    setIndividualStakeholders(null)
                                    setNewEntryButtonClicked(true)
                                  }}
                                  fieldClicked={fieldClicked}
                                  setOpenUserDropdown={setOpenUserDropdown}
                                  isDisabled={individualStakeholders?.lastName}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Last Name' })}
                                  onFocus={(e: any) =>
                                    onClickFocusText(e, formik, boardMemberDetails)
                                  }
                                  ariaLabel='lastName'
                                  onBlur={(e: any) => onClickBlurText(e, formik)}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Email Id' })}
                                  fieldName='email'
                                  isDisabled={individualStakeholders?.email}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Email ID' })}
                                  toolTipText={formatMessage({
                                    id: 'Add email address of the board member here.',
                                  })}
                                  isStarRequired={true}
                                  ariaLabel='email'
                                  onFocus={(e: any) =>
                                    onClickFocusText(e, formik, boardMemberDetails)
                                  }
                                  onBlur={(e: any) => onClickBlurText(e, formik)}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <InputWithPhone
                                  fieldName='phone'
                                  selectOptionFieldName='phoneCode'
                                  label={formatMessage({ id: 'Phone' })}
                                  placeholder={formatMessage({ id: 'Enter Phone Number' })}
                                  placeholderSelect='+91'
                                  formik={formik}
                                  disabled={
                                    individualStakeholders?.phoneCode &&
                                    individualStakeholders?.phoneNumber
                                  }
                                  options={phoneCodesOptions}
                                  toolTipText={formatMessage({
                                    id: 'Select country code and add phone number of the board member you are adding.',
                                  })}
                                  isStarRequired={true}
                                  isTooltipForModal={true}
                                  onBlur={formik.handleBlur}
                                  onFocus={formik.handleFocus}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <SelectInput
                                  label={formatMessage({ id: 'Gender' })}
                                  fieldName='gender'
                                  placeholder={formatMessage({
                                    id: 'Select Gender',
                                  })}
                                  formik={formik}
                                  disabled={individualStakeholders?.gender}
                                  toolTipText={formatMessage({
                                    id: 'Select gender of the board member being added.',
                                  })}
                                  options={['Male', 'Female', 'Others']}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='date'
                                  label={formatMessage({ id: 'Date of birth' })}
                                  fieldName='dateOfBirth'
                                  isDisabled={individualStakeholders?.dateOfBirth}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Select Date of birth' })}
                                  toolTipText={formatMessage({
                                    id: 'Add date of birth of the board member.',
                                  })}
                                  isStarRequired={false}
                                  isDateOfBirth={true}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                            </div>

                            <div className='mb-4'>
                              <h2 className='font-size-16 mb-4'>
                                {formatMessage({ id: 'Personal Details' })}
                              </h2>
                              <div className='row'>
                                <div className='col-md-6 col-12'>
                                  <TextInput
                                    fieldType='text'
                                    label={formatMessage({ id: 'Company Name' })}
                                    fieldName='workCompanyName'
                                    isDisabled={individualStakeholders?.workCompanyName}
                                    formik={formik}
                                    placeholder={formatMessage({ id: 'Enter Company Name' })}
                                    toolTipText={formatMessage({
                                      id: 'Add the name of the company to which this Board Member belongs.',
                                    })}
                                    isStarRequired={false}
                                  />
                                </div>
                                <div className='col-md-6 col-12'>
                                  <SelectInput
                                    label={formatMessage({ id: 'Industry' })}
                                    fieldName='workIndustry'
                                    placeholder={formatMessage({
                                      id: 'Select Industry',
                                    })}
                                    disabled={individualStakeholders?.workIndustry}
                                    formik={formik}
                                    toolTipText={formatMessage({
                                      id: 'Select the industry of the added company.',
                                    })}
                                    options={industryOptions}
                                    isStarRequired={false}
                                  />
                                </div>
                                <div className='col-md-6 col-12'>
                                  <TextInput
                                    fieldType='number'
                                    label={formatMessage({ id: 'Experience (In Year)' })}
                                    fieldName='workExperience'
                                    isDisabled={individualStakeholders?.workExperience}
                                    formik={formik}
                                    placeholder={formatMessage({ id: 'Enter Experience (in Year)' })}
                                    toolTipText={formatMessage({
                                      id: 'Specify the professional experience (in number of years) of the respective Board Member.',
                                    })}
                                    isStarRequired={false}
                                  />
                                </div>
                                <div className='col-md-6 col-12'>
                                  <TextInput
                                    fieldType='text'
                                    label={formatMessage({ id: 'Board Task Preference' })}
                                    fieldName='boardTaskPreferences'
                                    formik={formik}
                                    placeholder={formatMessage({
                                      id: 'Enter Task Preference (i.e sales, marketing, tech)',
                                    })}
                                    toolTipText={formatMessage({
                                      id: 'Specify the task board preference(i.e sales, marketing, tech) of this Board Member.',
                                    })}
                                    isStarRequired={false}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className='d-md-flex justify-content-end gap-2 mt-10'>
                              <div className='d-flex flex-reverse flex-column flex-md-row gap-2 gap-md-4 w-100'>
                                <div className='d-flex flex-row justify-content-between w-100'>
                                  <div>
                                    {!boardMemberDetails && (
                                      <button
                                        type='button'
                                        onClick={() => {
                                          if (individualStakeholders) {
                                            setClearFormDataShowModal(true)
                                          } else {
                                            resetFields(formik, boardMemberSidebarFields)
                                          }
                                        }}
                                        disabled={
                                          !individualStakeholders &&
                                          Object.entries(formik.values)
                                            // Filter only those keys that exist in the current sidebar's fields
                                            .filter(([key]) =>
                                              boardMemberSidebarFields[
                                                formik.values.sidebar as 1 | 2 | 3
                                              ]?.includes(key)
                                            )
                                            .filter(
                                              ([key]) => !['gender', 'phoneCode'].includes(key)
                                            )
                                            .every(
                                              ([_, value]) =>
                                                value === null ||
                                                value === '' ||
                                                (Array.isArray(value) && value.length === 0) // Handle empty arrays as empty
                                            )
                                        }
                                        className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1'
                                      >
                                        {formatMessage({
                                          id: individualStakeholders ? 'Clear All' : 'Clear',
                                        })}
                                      </button>
                                    )}
                                  </div>
                                  <div>
                                    <button
                                      className='btn bg-light custom-button-property border border-1 mb-md-4 mb-2 px-6 py-4 text-muted text-center w-100 w-md-auto order-2 order-md-1 me-4'
                                      onClick={() => {
                                        navigate('/stakeholders/board-member')
                                      }}
                                    >
                                      {formatMessage({ id: 'Cancel' })}
                                    </button>
                                    <button
                                      type='button'
                                      onClick={() => {
                                        setSidebar(sidebar + 1)
                                        if (formikRef.current)
                                          formikRef.current.setFieldValue('sidebar', sidebar + 1)
                                      }}
                                      disabled={
                                        individualStakeholders
                                          ? false
                                          : edit === 'true'
                                            ? !formik.isValid
                                            : !formik.isValid || !formik.dirty
                                      }
                                      className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1 order-md-2'
                                    >
                                      {formatMessage({ id: 'Next' })}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {sidebar === 2 && (
                    <div className='hide-scrollbar' style={{ height: '100vh', overflowY: 'auto' }}>
                      <div className='mb-4'>
                        <h2 className='font-size-16 mb-5'>
                          {formatMessage({ id: 'Board Members’s Official Address' })}
                        </h2>

                        <div className=''>
                          <InfoCard2
                            className='w-100'
                            title={formatMessage({
                              id: "How Can You Add a Board Member's Official Address?",
                            })}
                            desc={formatMessage({
                              id: "Easily add and manage a board member's official address by filling in the necessary details on the portal. Keep all important contact information centralized and accessible for seamless communication and record-keeping.",
                            })}
                            slug={brandingConfig.helpLinks.addBoardMemberAddress}
                          />
                        </div>

                        {boardMemberDetailsLoading || stakeHoldersDataLoading ? (
                          <div className='col-xl-12 d-md-flex'>
                            <div>
                              <div
                                className={`card position-relative d-flex justify-content-center`}
                              >
                                <Skeleton
                                  height={130}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                />{' '}
                              </div>
                            </div>
                            <div className='mt-md-8 w-100 px-5 px-md-0 mb-4'>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className='w-100 mt-10'>
                            <div className='row'>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Address Line 1' })}
                                  fieldName='address1'
                                  isDisabled={individualStakeholders?.address1}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Address Line 1' })}
                                  toolTipText={formatMessage({
                                    id: 'Add a correspondence address of the board member.',
                                  })}
                                  isStarRequired={false}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Address Line 2' })}
                                  fieldName='address2'
                                  isDisabled={individualStakeholders?.address2}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Address Line 2' })}
                                  toolTipText={formatMessage({
                                    id: 'Add a correspondence address of the board member.',
                                  })}
                                  isStarRequired={false}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <SelectSearchInput
                                  label={formatMessage({ id: 'Country' })}
                                  fieldName='country'
                                  disabled={individualStakeholders?.country}
                                  placeholder={formatMessage({ id: 'Select Country' })}
                                  formik={formik}
                                  toolTipText={formatMessage({
                                    id: 'Add country where the board member resides.',
                                  })}
                                  options={countryOptions}
                                  isStarRequired
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                {stateDataLoading ? (
                                  <div className='col-md-5 mb-10 mb-md-0'>
                                    <div className='w-50'>
                                      <Skeleton
                                        height={20}
                                        baseColor='var(--kt-skeleton-bg-color)'
                                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                      />
                                    </div>
                                    <div className='mt-2'>
                                      <Skeleton
                                        height={30}
                                        baseColor='var(--kt-skeleton-bg-color)'
                                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  <SelectSearchInput
                                    label={formatMessage({ id: 'State' })}
                                    fieldName='state'
                                    placeholder={formatMessage({ id: 'Select State' })}
                                    formik={formik}
                                    disabled={individualStakeholders?.state}
                                    toolTipText={formatMessage({
                                      id: 'Specify the state where the board member resides',
                                    })}
                                    options={stateOptions}
                                    isStarRequired={true}
                                  />
                                )}
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'City' })}
                                  fieldName='city'
                                  formik={formik}
                                  isDisabled={individualStakeholders?.city}
                                  placeholder={formatMessage({ id: 'Enter City' })}
                                  toolTipText={formatMessage({
                                    id: 'Add city of the board member here.',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='string'
                                  label={formatMessage({ id: 'Zipcode' })}
                                  fieldName='zipCode'
                                  isDisabled={individualStakeholders?.zipCode}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Zipcode' })}
                                  toolTipText={formatMessage({
                                    id: "Add ZIP code of the board member's city.",
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                            </div>

                            <div className='d-md-flex justify-content-end gap-2 mt-10'>
                              <div className='d-flex flex-reverse flex-column flex-md-row gap-2 gap-md-4 w-100'>
                                <div className='d-flex flex-row justify-content-between w-100'>
                                  <div>
                                    {!boardMemberDetails && (
                                      <button
                                        type='button'
                                        onClick={() => {
                                          if (individualStakeholders) {
                                            setClearFormDataShowModal(true)
                                          } else {
                                            resetFields(formik, boardMemberSidebarFields)
                                          }
                                        }}
                                        disabled={
                                          !individualStakeholders &&
                                          Object.entries(formik.values)
                                            .filter(([key]) =>
                                              boardMemberSidebarFields[
                                                formik.values.sidebar as 1 | 2 | 3
                                              ]?.includes(key)
                                            )
                                            .every(
                                              ([_, value]) =>
                                                value === null ||
                                                value === '' ||
                                                (Array.isArray(value) && value.length === 0)
                                            )
                                        }
                                        className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1'
                                      >
                                        {formatMessage({
                                          id: individualStakeholders ? 'Clear All' : 'Clear',
                                        })}
                                      </button>
                                    )}
                                  </div>
                                  <div>
                                    <button
                                      className='btn bg-light custom-button-property border border-1 mb-md-4 mb-2 px-6 py-4 text-muted text-center w-100 w-md-auto order-2 order-md-1 me-4'
                                      onClick={() => {
                                        setSidebar(sidebar - 1)
                                        if (formikRef.current) {
                                          formikRef.current.setFieldValue('sidebar', sidebar - 1)
                                        }
                                      }}
                                    >
                                      {formatMessage({ id: 'Back' })}
                                    </button>
                                    <button
                                      type='button'
                                      onClick={() => {
                                        setSidebar(sidebar + 1)
                                        if (formikRef.current)
                                          formikRef.current.setFieldValue('sidebar', sidebar + 1)
                                      }}
                                      disabled={
                                        individualStakeholders
                                          ? false
                                          : edit === 'true'
                                            ? !formik.isValid
                                            : !formik.isValid || !formik.dirty
                                      }
                                      className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1 order-md-2'
                                    >
                                      {formatMessage({ id: 'Next' })}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {sidebar === 3 && (
                    <div className='hide-scrollbar' style={{ height: '100vh', overflowY: 'auto' }}>
                      <div className='mb-4'>
                        <h2 className='font-size-16 mb-5'>
                          {formatMessage({ id: 'Board Member’s Other Details' })}
                        </h2>

                        <div className=''>
                          <InfoCard2
                            className='w-100'
                            title={formatMessage({
                              id: 'Adding Important Details About Board Members',
                            })}
                            desc={formatMessage({
                              id: `Easily fill in key information such as designation, nationality, education, and more to maintain comprehensive and organized stakeholder profiles on the ${brandingConfig.brandName} portal.`,
                            })}
                            slug={brandingConfig.helpLinks.addBoardMemberOtherDetails}
                          />
                        </div>

                        {boardMemberDetailsLoading || stakeHoldersDataLoading ? (
                          <div className='col-xl-12 d-md-flex'>
                            <div>
                              <div
                                className={`card position-relative d-flex justify-content-center`}
                              >
                                <Skeleton
                                  height={130}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                />{' '}
                              </div>
                            </div>
                            <div className='mt-md-8 w-100 px-5 px-md-0 mb-4'>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className='w-100 mt-10'>
                            <div className='row'>
                              <div className='col-md-6 col-12'>
                                <SelectSearchInput
                                  label={formatMessage({ id: 'Nationality' })}
                                  fieldName='nationality'
                                  formik={formik}
                                  disabled={individualStakeholders?.nationality}
                                  placeholder={formatMessage({ id: 'Enter Nationality' })}
                                  toolTipText={formatMessage({
                                    id: 'Add nationality of the board member.',
                                  })}
                                  options={countryOptions}
                                  isStarRequired={false}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Designation' })}
                                  fieldName='designation'
                                  isDisabled={individualStakeholders?.designation}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Designation' })}
                                  toolTipText={formatMessage({
                                    id: 'Designation refers to the specific position or role assigned to an employee within the company. It typically highlights the function or duties an employee is responsible for. For eg. CEO, Marketing Manager etc.',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <SelectHeaderDropDown
                                  label={formatMessage({ id: 'Govt. issued ID type' })}
                                  toolTipText={formatMessage({
                                    id: 'Add Govt. issued ID type of the member of the board member.',
                                  })}
                                  placeholder='Select Govt. issued ID type'
                                  fieldName='govtIssuedIdType'
                                  disabled={individualStakeholders?.govtIssuedIdType}
                                  formik={formik}
                                  isStarRequired
                                  dropdownOptions={govtIdOptions}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Govt. Issued ID Number' })}
                                  fieldName='govtIssuedIdNumber'
                                  formik={formik}
                                  placeholder={formatMessage({
                                    id: 'Enter Govt. Issued ID Number',
                                  })}
                                  toolTipText={formatMessage({
                                    id: 'Enter the number of Govt. Issued ID selected for this board member.',
                                  })}
                                  isStarRequired={false}
                                  isDisabled={individualStakeholders?.govtIssuedIdNumber}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Title' })}
                                  fieldName='title'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter title.' })}
                                  toolTipText={formatMessage({
                                    id: 'Title often represents the formal name or position given to an employee, which could be more about how the company wants to present the role publicly or in a business setting. A title might be broader or even more formal than a designation. For eg. Director of Operations, Head of Engineering.',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Website' })}
                                  isDisabled={individualStakeholders?.website}
                                  fieldName='website'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Website url' })}
                                  toolTipText={formatMessage({
                                    id: 'Add a website of the board member or of the company they represent.',
                                  })}
                                  onBlur={formik.handleBlur}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Education' })}
                                  fieldName='education'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Education' })}
                                  toolTipText={formatMessage({
                                    id: 'Add Education of the board member.',
                                  })}
                                  isStarRequired={false}
                                  isDisabled={individualStakeholders?.education}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TagInput
                                  label={formatMessage({ id: 'Skills and Expertise' })}
                                  initialOptions={designationOptions}
                                  placeholder={formatMessage({ id: 'Enter Skills and Expertise' })}
                                  tooltip={formatMessage({
                                    id: 'Add Skills and Expertise of the board member.',
                                  })}
                                  fieldName='skills'
                                  formik={formik}
                                  disabled={individualStakeholders?.skills}
                                />
                              </div>
                              <div className='col-md-6 col-12 z-index-0'>
                                <TagifyInput
                                  label={formatMessage({ id: 'Other Affiliations (if any)' })}
                                  placeholder={formatMessage({ id: 'Enter other affiliations' })}
                                  tooltip={formatMessage({
                                    id: 'Add other affliates of the board member.',
                                  })}
                                  fieldName='otherAffiliations'
                                  formik={formik}
                                  disabled={individualStakeholders?.otherAffiliations}
                                />
                              </div>
                            </div>

                            <div className='d-md-flex justify-content-end gap-2 mt-10'>
                              <div className='d-flex flex-reverse flex-column flex-md-row gap-2 gap-md-4 w-100'>
                                <div className='d-flex flex-row justify-content-between w-100'>
                                  <div>
                                    {!boardMemberDetails && (
                                      <button
                                        type='button'
                                        onClick={() => {
                                          if (individualStakeholders) {
                                            setClearFormDataShowModal(true)
                                          } else {
                                            resetFields(formik, boardMemberSidebarFields)
                                          }
                                        }}
                                        disabled={
                                          !individualStakeholders &&
                                          Object.entries(formik.values)
                                            // Filter only those keys that exist in the current sidebar's fields
                                            .filter(([key]) =>
                                              boardMemberSidebarFields[
                                                formik.values.sidebar as 1 | 2 | 3
                                              ]?.includes(key)
                                            )
                                            .every(
                                              ([_, value]) =>
                                                value === null ||
                                                value === '' ||
                                                (Array.isArray(value) && value.length === 0)
                                            )
                                        }
                                        className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1'
                                      >
                                        {formatMessage({
                                          id: individualStakeholders ? 'Clear All' : 'Clear',
                                        })}
                                      </button>
                                    )}
                                  </div>
                                  <div>
                                    <button
                                      className='btn bg-light custom-button-property border border-1 mb-md-4 mb-2 px-6 py-4 text-muted text-center w-100 w-md-auto order-2 order-md-1 me-4'
                                      onClick={() => {
                                        setSidebar(sidebar - 1)
                                        if (formikRef.current) {
                                          formikRef.current.setFieldValue('sidebar', sidebar - 1)
                                        }
                                      }}
                                    >
                                      {formatMessage({ id: 'Back' })}
                                    </button>
                                    <button
                                      type='button'
                                      onClick={() => {
                                        setSidebar(sidebar + 1)
                                        if (formikRef.current)
                                          formikRef.current.setFieldValue('sidebar', sidebar + 1)
                                      }}
                                      disabled={
                                        individualStakeholders
                                          ? false
                                          : edit === 'true'
                                            ? !formik.isValid
                                            : !formik.isValid || !formik.dirty
                                      }
                                      className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1 order-md-2'
                                    >
                                      {formatMessage({ id: 'Next' })}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {sidebar === 4 && (
                    <>
                      <div className=''>
                        <h2 className='font-size-16 mb-5'>
                          {formatMessage({ id: 'Documents related to this Board member' })}
                        </h2>
                        <div className=''>
                          <InfoCard2
                            className='w-100'
                            title={formatMessage({
                              id: 'Upload Stakeholder Documents',
                            })}
                            desc={formatMessage({
                              id: 'Easily upload and manage important documents related to each stakeholder, detailing their relationship with the company, for comprehensive and organized records.',
                            })}
                            slug={brandingConfig.helpLinks.addBoardMemberDocuments}
                          />
                        </div>
                        <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                          {formatMessage({ id: 'Attach files' })}{' '}
                          <ToolTipUIForModal
                            tooltipText={formatMessage({
                              id: 'Add/upload documents related to the board member being added here.',
                            })}
                          />
                        </div>
                        <FileUpload
                          fileSize={parseInt(
                            process.env.REACT_APP_STAKEHOLDERS_MAX_FILE_SIZE as string
                          )}
                          maxFileNumber={10}
                          allowType={allowedFileTypes}
                          metaData={{ module: 'document', isProtected: false }}
                          modalStatus={modelStatus}
                          handleClose={() => {
                            TagManager.dataLayer({
                              dataLayer: {
                                event: GTMEvent.BoardMemberCreateOrUpdateDocumentsUploadFailed,
                                action: 'normal',
                                metadata: {
                                  company_id: companyId,
                                  user_id: currentUser?.userId,
                                  email: currentUser?.email,
                                },
                              },
                            })
                            setModelStatus(false)
                          }}
                          handleSuccess={(id: number, name: string) => {
                            setIsNotInitiaized(false)

                            setFiles((prevFiles: any) => [...prevFiles, { id, name }])

                            if (formikRef.current) {
                              const currentFileIds = Array.isArray(formikRef.current.values.fileIds)
                                ? formikRef.current.values.fileIds
                                : []

                              fileRef.current.push(id) // Store only the current ID
                              const uniqueFileIds = Array.from(
                                new Set([...currentFileIds, ...fileRef.current])
                              )
                              formikRef.current.setFieldValue('fileIds', uniqueFileIds)
                              TagManager.dataLayer({
                                dataLayer: {
                                  event:
                                    GTMEvent.BoardMemberCreateOrUpdateDocumentsUploadSuccessful,
                                  action: 'normal',
                                  metadata: {
                                    company_id: companyId,
                                    user_id: currentUser?.userId,
                                    email: currentUser?.email,
                                    document_name: name,
                                    document_id: id,
                                  },
                                },
                              })
                            }
                          }}
                          resourceType='all'
                        />
                        <div className='w-100'>
                          <button
                            type='button'
                            className='btn bg-primary custom-button-property text-white border border-1 mb-4 px-6 py-4 text-center w-100 w-md-auto'
                            onClick={() => setModelStatus(true)}
                          >
                            {formatMessage({ id: 'Import Files' })}
                          </button>
                        </div>
                      </div>

                      <div className='mb-4'>
                        {files.length > 0 && (
                          <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                            {formatMessage({ id: 'Uploaded Files' })}{' '}
                            <ToolTipUIForModal
                              tooltipText={formatMessage({
                                id: 'Manage all the uploaded documents here.',
                              })}
                            />
                          </div>
                        )}
                        {boardMemberDetailsLoading ? (
                          <>
                            <div className='w-50'>
                              <Skeleton
                                width={'100%'}
                                height={48}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                              />
                            </div>
                            <div className='w-50'>
                              <Skeleton
                                width={'100%'}
                                height={48}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                              />
                            </div>
                          </>
                        ) : (
                          <div className='w-100'>
                            <ul className='p-0 m-0'>
                              {files?.map((file: any) => (
                                <li
                                  key={file.id}
                                  className='d-flex align-items-center gap-2 text-decoration-none mb-3 w-100 border border-1 p-2'
                                >
                                  <div className='d-flex justify-content-between align-items-center w-100'>
                                    <div className='w-100 d-flex align-items-center gap-2'>
                                      <img
                                        src={getFileType(file.name)}
                                        alt={file.name}
                                        style={{ height: '30px', width: '30px' }}
                                      />

                                      <p className='p-0 m-0 max-file-width'>
                                        {file.name.split('/').pop()}
                                      </p>
                                    </div>

                                    <button
                                      type='button'
                                      className='btn btn-secondry p-0 m-0  d-flex align-items-start'
                                      onClick={() => {
                                        setDeleteFileId(file.id)
                                        setDeleteShowModal(true)
                                      }}
                                    >
                                      <img src={deleteicon} alt='Delete' />
                                    </button>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}

                        <div className='d-md-flex justify-content-end gap-2 mt-10'>
                          <div className='d-flex flex-reverse flex-column flex-md-row gap-2 gap-md-4'>
                            <button
                              className='btn bg-light custom-button-property border border-1 mb-md-4 mb-2 px-6 py-4 text-muted text-center w-100 w-md-auto order-2 order-md-1'
                              onClick={() => {
                                setSidebar(sidebar - 1)
                                if (formikRef.current) {
                                  formikRef.current.setFieldValue('sidebar', sidebar - 1)
                                }
                              }}
                            >
                              {formatMessage({ id: 'Back' })}
                            </button>
                            <button
                              className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1 order-md-2'
                              disabled={!formik.isValid || isLoading}
                            >
                              {!isLoading && (
                                <span className='indicator-label font-size-13 p-0'>
                                  {formatMessage({ id: 'Submit' })}
                                </span>
                              )}
                              {isLoading && (
                                <span className='indicator-label font-size-13 p-0'>
                                  {formatMessage({ id: 'Please wait...' })}
                                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </Form>
              )
            }}
          </Formik>
        </div>
      </div>
      <DeleteFileConfirmationModal
        setDeleteShowModal={setDeleteShowModal}
        showDeleteModal={showDeleteModal}
        onDeleteSubmit={deleteFile}
        deleteLoading={deleteLoading}
        header='Delete File'
        paragraph='Are you sure you want to delete this file?'
      />
      <DeleteFileConfirmationModal
        setDeleteShowModal={setClearFormDataShowModal}
        showDeleteModal={clearFormDataShowModal}
        onDeleteSubmit={handleClearFormData}
        deleteLoading={clearFormDataLoading}
        header='Clear Form Data In Steps'
        paragraph='Are you sure you want to clear all the form data across the steps (Personal Details, Address, Other Details)?'
      />
    </>
  )
}
